import { defaultTheme } from "react-admin";
import merge from "lodash/merge";

import indigo from "@material-ui/core/colors/indigo";
import pink from "@material-ui/core/colors/pink";
import red from "@material-ui/core/colors/red";

export const theme = merge({}, defaultTheme, {
  palette: {
    primary: indigo,
    secondary: pink,
    error: red,
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
  typography: {
    // Use the system font instead of the default Roboto font.
    h3: {
      marginBottom: "0px !important",
    },
    h6: {
      marginBottom: "-10px",
    },
    subtitle2: {
      marginBottom: "-10px",
    },
    fontFamily: [
      "DM Sans",
      "-apple-system",
      "BlinkMacSystemFont",
      "Arial",
      "sans-serif",
    ].join(","),
  },
  sidebar: {
    width: 290,
    closedWidth: 55,
  },
  overrides: {
    MuiAlertTitle: {
      root: {
        fontWeight: "800",
      },
    },
    MuiFormControl: {
      marginDense: {
        width: "100%",
      },
    },
    MuiFilledInput: {
      root: {
        backgroundColor: "white !important",
        border: "1px solid #eaeaea",
        borderRadius: "10px !important",
      },
      underline: {
        "&:before": {
          border: "none !important",
        },
      },
    },
    MuiAppBar: {
      colorSecondary: {
        boxShadow: "0 0px 18px rgb(0 0 0 / 10%)",
        color: "#6777ef",
        backgroundColor: "#ffffff",
      },
    },
    MuiPaper: {
      elevation1: {
        boxShadow: "0 4px 8px rgb(0 0 0 / 3%)",
      },
      elevation4: {
        boxShadow: "0 4px 8px rgb(0 0 0 / 3%)",
      },
      elevation8: {
        boxShadow: "0 4px 8px rgb(0 0 0 / 10%)",
      },
      rounded: {
        borderRadius: "10px",
      },
    },
    MuiListItemIcon: {
      root: {
        color: "inherit",
      },
    },
    MuiListItem: {
      gutters: {
        minHeight: "36px !important",
        marginBottom: "20px !important",
        width: "90%",
        borderRadius: "0px",
        "@media (min-width: 600px)": {
          minHeight: "36px",
        },
        paddingLeft: "15px",
        paddingRight: "15px",
        position: "relative",
      },
    },
    MuiTypography: {
      body2: {
        fontWeight: 500,
      },
      h4: {
        fontWeight: "bold",
      },
      h5: {
        fontWeight: "bold",
      },
      h6: {
        fontWeight: "bold",
      },
      subtitle1: {
        fontWeight: "bold",
      },
      subtitle2: {
        fontWeight: "bold",
      },
    },
    MuiBreadcrumbs: {
      ol: {
        color: "#707EAE",
        fontWeight: 500,
      },
    },
    MuiButton: {
      root: {
        "&.Mui-disabled": {
          color: "#aeaeaeab",
        },
      },
      contained: {
        marginLeft: 10,
      },
      textSizeSmall: {
        padding: "5px 10px",
        fontSize: "0.8125rem",
      },
      text: {
        paddingLeft: 0,
      },
      containedSecondary: {
        marginLeft: 0,
      },
      containedPrimary: {
        backgroundColor: "#2B3674",
        "&:hover": {
          backgroundColor: "#0c3d86",
        },
      },
    },
    MuiTab: {
      root: {
        fontWeight: "600",
      },
    },
    MuiInputLabel: {
      formControl: {
        fontSize: "14px",
      },
    },
    MuiChip: {
      root: {
        fontWeight: "bold",
      },
    },
    RaSidebar: {
      root: {
        zIndex: 1100,
        height: "max-content",
        minHeight: "100vh",
      },
      drawerPaper: {
        paddingTop: "10px",
        backgroundColor: "#ffffff",
        "@media (min-width: 0px)": {
          height: "100%",
        },
      },
      fixed: {
        position: "relative",
        height: "max-content",
        minHeight: "100vh",
      },
    },
    RaFormInput: {
      input: {
        width: "100%",
      },
    },
    RaAutocompleteArrayInput: {
      inputInput: {
        border: "none !important",
      },
    },
    RaPaginationActions: {
      button: {
        color: "black",
        backgroundColor: "white",
        "&:hover": {
          backgroundColor: "#fff !important",
        },
      },
      currentPageButton: {
        color: "#000000",
        fontWeight: "bold",
        backgroundColor: "#f9f9f9",
      },
    },
    RaList: {
      root: {
        backgroundColor: "#FFFFFF",
        borderRadius: "20px",
        marginTop: "15px",
      },
      main: {
        marginTop: "15px",
        "& .MuiPaper-root": {
          boxShadow: "none",
        },
        "& .MuiTableCell-head": {
          color: "#A3AED0",
          fontWeight: "500",
          textTransform: "uppercase",
          padding: "20px 10px 0px 10px",
          border: "0",
        },
        "& .MuiTableCell-body": {
          color: "#2B3674",
          fontWeight: "500",
          padding: "30px 10px",
          borderBottom: "1px solid #B5B5B5",
        },
      },
    },
    RaListToolbar: {
      toolbar: {
        alignItems: "center",
        "& .MuiButton-root": {
          borderRadius: "10px",
        },
      },
    },
    RaLayout: {
      root: {
        backgroundColor: "#F8FBFF",
      },
      content: {
        "@media (min-width: 0px)": {
          padding: "40px",
        },
      },
      appFrame: {
        "@media (min-width: 0px)": {
          marginTop: "0px",
        },
      },
    },
    RaMenuItemLink: {
      root: {
        color: "#2B3674 !important",
        fontWeight: "500",
        "&:hover": {
          borderRight: "3px solid #127EF1",
        },
      },
      active: {
        color: "#2B3674 !important",
        backgroundColor: "#FFFFFF",
        fontWeight: "700",
        "& $icon": {
          color: "#127EF1",
        },
        borderRight: "3px solid #127EF1",
      },
    },
    RaButton: {
      button: {
        margin: "5px 0px",
        marginLeft: "14px",
        backgroundColor: "#2B3674",
        "&:hover": {
          backgroundColor: "#0c3d86",
        },
        color: "white",
        fontWeight: "bold",
      },
    },
    RaLogout: {
      icon: {
        color: "rgba(0, 0, 0, 0.54)",
      },
    },
    RaDeleteWithUndoButton: {
      deleteButton: {
        padding: "7px 14px",
        color: "#ffffff",
        backgroundColor: "#f44336",
        "&:hover": {
          backgroundColor: "#f44336 !important",
        },
      },
    },
    RaDeleteWithConfirmButton: {
      deleteButton: {
        padding: "7px 14px",
        color: "#ffffff",
        backgroundColor: "#f44336",
        "&:hover": {
          backgroundColor: "#f44336 !important",
        },
      },
    },
    RaFileInputPreview: {
      removeButton: {
        display: "none",
      },
    },
    RaAppBar: {
      title: {
        marginBottom: 0,
      },
    },
    RaFilterForm: {
      form: {
        "& .MuiFilledInput-inputHiddenLabel.MuiFilledInput-inputMarginDense": {
          paddingTop: "6px",
          paddingBottom: "14px",
        },
      },
    },
    RaTopToolbar: {
      root: {
        justifyContent: "flex-end",
        "& .MuiButton-root": {
          marginLeft: 0,
          marginRight: 10,
        },
      },
    },
    RaTabbedShowLayout: {
      content: {
        padding: "24px 34px !important",
      },
    },
    RaSearchInput: {
      input: {
        "& .MuiFilledInput-adornedEnd": {
          paddingTop: "8px",
        },
      },
    },
  },
});
